export default __webpack_public_path__ + "static/media/q23_02.ac4c0272.png";